<div class="card-container">
  <div class="card-inner">
    <ng-content></ng-content>
  </div>
</div>
